import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Menu from "@/components/Menu";
import HowToOrder from "@/components/HowToOrder";
import Story from "@/components/Story";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import Success from "@/pages/Success";
import PaymentCancelled from "@/pages/PaymentCancelled";
import CheckoutPage from "@/pages/CheckoutPage";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";

const Home = () => (
  <>
    <Header />
    <Hero />
    <Menu />
    <HowToOrder />
    <Story />
    <Footer />
    <CartDrawer />
  </>
);

// Detect session_id in URL fragment synchronously during render (not in useEffect)
// to prevent race conditions with AuthProvider checkAuth.
const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/success" element={<Success />} />
      <Route path="/payment-success" element={<Success />} />
      <Route path="/payment-cancelled" element={<PaymentCancelled />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
};

const App = () => {
  useEffect(() => {
    document.title = "Afro World Delight | Authentic West African Cuisine";
  }, []);

  return (
    <div className="App grain">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
};

export default App;
